import { Navigate, Outlet, useLocation } from 'react-router';

import { useAuth } from './AuthProvider';

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'restoring') return <SessionSplash />;
  if (status === 'anonymous') {
    const next = location.pathname + location.search + location.hash;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <Outlet />;
}

export function SessionSplash() {
  return (
    <div role="status" className="grid h-dvh place-items-center bg-canvas">
      <div className="flex flex-col items-center gap-3 text-fg-subtle">
        <span
          aria-hidden="true"
          className="size-5 animate-spin rounded-full border-2 border-line-strong border-t-accent"
        />
        <span className="text-xs">Restaurando sessão…</span>
      </div>
    </div>
  );
}
